import { CaseManagementData } from "../application";
import { EventBase } from "../common";
export interface SafetyCheckNotificationEventArgs {
  caseId: string;
  management: CaseManagementData;
}
export class SafetyCheckUpdatedEvent extends EventBase<SafetyCheckNotificationEventArgs> {
  constructor(notification: SafetyCheckNotificationEventArgs) {
    super();
    this.args = notification;
  }
}
